<script lang="ts" setup>

import {XCircleIcon} from "@heroicons/vue/24/outline";
import IconButton from "@src/components/ui/inputs/IconButton.vue";
import SlideTransition from "@src/components/ui/transitions/SlideTransition.vue";
import {useChatSessionStore} from "@src/stores/chatSession";
import MessagePreview from "@src/components/views/HomeView/MainArea/ChatArea/Message/MessagePreview.vue";

const sessionStore = useChatSessionStore();

// (event) hide the pinned message
const handleHidePinnedMessage = () => {
    if (sessionStore.selectedSession) {
        sessionStore.selectedSession.pinned_message_hidden = true;
    }
};

// (event) remove the pinned message
const handleRemovePinnedMessage = () => {
    if (sessionStore.selectedSession) {
        sessionStore.selectedSession.pinned_message_hidden = true;
        sessionStore.selectedSession.pinned_message = null;

        // send socket message notifying other users that the message is removed
        // ...
    }
};
const scrollToPinnedMessage = () => {
    const pinned = sessionStore.selectedSession?.pinned_message;
    if (!pinned) return;

    sessionStore.scrollToMessage(pinned.id!);
};
</script>

<template>
    <SlideTransition animation="shelf-down">
        <div
            v-if="
                sessionStore.selectedSession?.pinned_message
            "
            class="absolute z-10 w-full px-5 py-5 bg-white dark:bg-gray-800 cursor-pointer flex items-center justify-between transition-all duration-500 hover:bg-indigo-50"
            @click="scrollToPinnedMessage"
        >
            <!--pinned message preview-->
            <MessagePreview :input="true" :message="sessionStore.selectedSession?.pinned_message"
                            :session="sessionStore.selectedSession"/>

            <div class="flex">
                <!--remove pinned Message-->
                <IconButton
                    aria-label="close pinned message"
                    class="ic-btn-ghost-primary cursor-pointer w-7 h-7"
                    title="close pinned message"
                    @click="handleRemovePinnedMessage"
                >
                    <XCircleIcon class="w-5 h-5"/>
                </IconButton>
            </div>
        </div>
    </SlideTransition>
</template>
